import Typekey from '@/userManagement/Typekey';

export default class PostType extends Typekey {
  static readonly user = new PostType('user', 'User', '');

  static readonly organization = new PostType('organization', 'Organization', '');

  static readonly group = new PostType('group', 'Group', '');

  static allStates() {
    return [
      PostType.user,
      PostType.organization,
      PostType.group,
    ];
  }
}
